import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { VsChange } from 'common/components/VsChange';
import { ProgressBar } from 'common/components/ProgressBar';
import { IMonitorSalesSummaryMetric } from 'entities/MonitorSales/MonitorSales.models';
import { formatValue } from 'entities/MonitorSales/monitorSales.helpers';

interface ISummaryRowProps {
  label: string;
  metric?: IMonitorSalesSummaryMetric;
}

export const SummaryRow: FC<ISummaryRowProps> = ({ label, metric }) => {
  const { actual = 0, target = 0, percent = 0, vsLastPeriod = 0, vsLastYear = 0 } = metric ?? {};

  return (
    <Row align="middle" gutter={24} className="mb-4">
      <Col span={18} className="ms-summary__main">
        <ProgressBar
          label={label}
          actual={formatValue(label, actual)}
          target={formatValue(label, target)}
          percent={percent}
        />
      </Col>

      <Col span={3}>
        <VsChange value={vsLastPeriod} />
      </Col>
      <Col span={3}>
        <VsChange value={vsLastYear} />
      </Col>
    </Row>
  );
};
